export default {
  title: {
    id: 'bo_seller-options-shipping-back_ship_title',
    defaultMessage: 'Grow with BackShip',
  },
  subtitle: {
    id: 'bo_seller-options-shipping-back_ship_subtitle',
    defaultMessage:
      'Backship is our international, express, and standard shipping service.',
  },
  automatic: {
    id: 'bo_seller-options-shipping-back_ship_automatic',
    defaultMessage: 'Automatic shipping labels',
  },
  grow: {
    id: 'bo_seller-options-shipping-back_ship_grow',
    defaultMessage: 'To grow serenely',
  },
  negociated: {
    id: 'bo_seller-options-shipping-back_ship_negotiated',
    defaultMessage: 'Negotiated prices for you',
  },
  tellMeMore: {
    id: 'bo_seller-options-shipping-back_ship_tell_me_more',
    defaultMessage: 'Tell me more',
  },
} as const
